<template>
  <div class="grid addhotel" v-loading="loading">

      <el-tooltip class="item back" effect="dark" content="torna in spiaggia" placement="left-start">
        <el-button><router-link :to="{path: '/hotel'}" class=""><i class="fas fa-umbrella-beach"></i></router-link></el-button>
        <!-- <router-link :to="{path: '/hotel'}" class=""><i class="fas fa-umbrella-beach"></i></router-link> -->
      </el-tooltip>

  <div class="grid generator">

  <div class="grid steps">
    
    <div style="width: auto; min-width: 960px;">
      <el-steps :active="grid.active" align-center finish-status="success">
        <el-step :title="option.title" :description="option.desc" :key="index" v-for="(option, index) in filteredSteps" @click.native="e => stepHandler(e, index)"></el-step>
      </el-steps>
    </div>

  </div>

  <!-- {{hotel}} -->

  <div class="grid cont">

  <div class="grid" id="one" v-if="grid.active === 0">

    <h2 v-if="!loading">Aggiungi il tuo Hotel</h2>

    <div class="spacer sm"></div>

      <el-form :model="hotel" :rules="rules" ref="formAddhotel" v-if="" status-icon>
        <el-form-item prop="name" label="Nome Hotel">
          <el-input v-model="hotel.name" placeholder="Nome Hotel" type="text" ></el-input>
        </el-form-item>

        <el-form-item prop="" label="Colore preferito">
          <el-color-picker v-model="hotel.colors.primary"></el-color-picker>
        </el-form-item>

        <div class="spacer sm"></div>

        <el-button-group>
          <el-button class="btn btn-blue" v-if="grid.active !== 0" type="button" icon="el-icon-arrow-left">Indietro</el-button>
          <el-button class="btn btn-blue" type="button" v-on:click="next('formAddhotel')">Avanti <i class="el-icon-arrow-right el-icon-right"></i></el-button>
        </el-button-group>

      </el-form>

      </div>

      <div id="two" v-if="grid.active === 1">

      <h2>Scegli il modello di spiaggia</h2>

      <div class="spacer sm"></div>

      <el-form :model="hotel" :inline="true" :rules="rules" ref="formAddhotel" v-if="" status-icon>
        <el-form-item prop="name">
          <el-radio v-model="hotel.beachtype" label="grid" border>Spiaggia con righe e colonne fisse <img src="/static/img/addhotel-grid.png"></el-radio>
        </el-form-item>

        <el-form-item prop="">
          <el-radio v-model="hotel.beachtype" label="canvas" border>Spiaggia libera, imposto gli ombrelloni da solo <img src="/static/img/addhotel-canvas.png"></el-radio>
        </el-form-item>


        <div class="spacer sm"></div>

        <el-button-group>
          <el-button class="btn btn-blue" v-if="grid.active !== 0" v-on:click="grid.active--" type="button" icon="el-icon-arrow-left">Indietro</el-button>
          <el-button class="btn btn-blue" type="button" v-on:click="changeStep">Avanti <i class="el-icon-arrow-right el-icon-right"></i></el-button>
        </el-button-group>
      </el-form>

      </div>


      <div id="three" v-if="grid.active === 2">

      <h3>Inserisci/cambia la lettera e il numero del primo ombrellone in fronte mare a sinistra</h3>

      <div class="spacer sm"></div>

      <div class="grid" style="grid-auto-flow: column; justify-content: space-between;">

      <div>

        <el-form :rules="rules" :model="hotel">

          <label class="el-form-item__label">Righe in Spiaggia</label>
          <el-form-item prop="rows">
            <el-input-number v-model="hotel.rows" :min="1" ></el-input-number>
          </el-form-item>

          <label class="el-form-item__label">Colonne in Spiaggia</label>
          <el-form-item prop="cols">
            <el-input-number v-model="hotel.cols" :min="1" ></el-input-number>
          </el-form-item>

            <el-form-item label="Lettera" prop="letterfirst">
              <el-input placeholder="prima lettera" v-model="letters.first"></el-input>
            </el-form-item>
            <el-form-item label="Numero" prop="numberfirst">
              <el-input placeholder="primo numero" v-model="numbers.first"></el-input>
            </el-form-item>

            <el-button-group>
              <el-button class="btn btn-blue" v-if="grid.active !== 0" v-on:click="grid.active--" type="button" icon="el-icon-arrow-left">Indietro</el-button>
              <el-button class="btn btn-blue" type="button" v-on:click="resetGrid">Avanti <i class="el-icon-arrow-right el-icon-right"></i></el-button>
            </el-button-group>
            </el-form>

        </div>


        <div class="grid step first" >

          <!-- <i class="fas fa-water"></i> -->

            <div class="grid ombrello" style="grid-template-columns: 1fr 1fr 1fr; grid-row-gap: 12px; grid-column-gap: 12px;">
                  <div class="blocco seat free first">
                    <a class="blocco nr" >{{letters.first}}{{numbers.first}}</a>
                  </div>
                  <div class="blocco seat free">
                    <a class="blocco nr" ></a>
                  </div>
                  <div class="blocco seat free">
                    <a class="blocco nr" ></a>
                  </div>
                  <div class="blocco seat free">
                    <a class="blocco nr" ></a>
                  </div>
                  <div class="blocco seat free">
                    <a class="blocco nr" ></a>
                  </div>
                  <div class="blocco seat free">
                    <a class="blocco nr" ></a>
                  </div>
                  <div class="blocco seat free">
                    <a class="blocco nr" ></a>
                  </div>
                  <div class="blocco seat free">
                    <a class="blocco nr" ></a>
                  </div>
                  <div class="blocco seat free">
                    <a class="blocco nr" ></a>
                  </div>
            </div>

          </div>

              </div>

              </div>

      <div id="four" v-if="grid.active === 3">

              <div class="spacer sm"></div>

              <div v-if="hotel.beachtype === 'grid'">

              <h2>Controlla e salve</h2>

              <div class="spacer sm"></div>

              <el-form :model="hotel" :inline="true" :rules="rules" ref="formAddhotel" v-if="" status-icon>
                <el-form-item prop="name" v-if="letters.first.length !== 0">
                  <el-radio v-model="hotel.gridtype" v-on:change="resetGrid" label="left" border>
                    <div class="grid ombrello" style="grid-template-columns: 1fr 1fr; grid-row-gap: 12px; grid-column-gap: 12px;">
                      <div class="blocco seat free first">
                        <a class="blocco nr" >{{pregrid.first.letter}}{{pregrid.first.number}}</a>
                      </div>
                      <div class="blocco seat free">
                        <a class="blocco nr" >{{pregrid.left.letter}}{{pregrid.left.number}}</a>
                      </div>
                      <div class="blocco seat free">
                        <a class="blocco nr" >{{pregrid.up.letter}}{{pregrid.up.number}}</a>
                      </div>
                      <div class="blocco seat free">
                        <a class="blocco nr" >{{pregrid.upleft.letter}}{{pregrid.upleft.number}}</a>
                      </div>
                    </div>
                  </el-radio>
                </el-form-item>

                <el-form-item prop="" v-if="letters.first.length !== 0">
                  <el-radio v-model="hotel.gridtype" v-on:change="resetGrid" label="up" border>
                    <div class="grid ombrello" style="grid-template-columns: 1fr 1fr; grid-row-gap: 12px; grid-column-gap: 12px;">
                      <div class="blocco seat free first">
                        <a class="blocco nr" >{{pregrid.first.letter}}{{pregrid.first.number}}</a>
                      </div>
                      <div class="blocco seat free">
                        <a class="blocco nr" >{{pregrid.up.letter}}{{pregrid.up.number}}</a>
                      </div>
                      <div class="blocco seat free">
                        <a class="blocco nr" >{{pregrid.left.letter}}{{pregrid.left.number}}</a>
                      </div>
                      <div class="blocco seat free">
                        <a class="blocco nr" >{{pregrid.upleft.letter}}{{pregrid.upleft.number}}</a>
                      </div>
                    </div>
                  </el-radio>
                </el-form-item>

                <el-form-item prop="">
                  <el-radio v-model="hotel.gridtype" v-on:change="resetGrid" label="empty" border>
                    <div class="grid ombrello" style="grid-template-columns: 1fr 1fr; grid-row-gap: 12px; grid-column-gap: 12px;">
                      <div class="blocco seat free first">
                        <a class="blocco nr" >{{Number(numbers.first)}}</a>
                      </div>
                      <div class="blocco seat free">
                        <a class="blocco nr" >{{Number(numbers.first) + 1}}</a>
                      </div>
                      <div class="blocco seat free">
                        <a class="blocco nr" >{{Number(numbers.first) + hotel.cols}}</a>
                      </div>
                      <div class="blocco seat free">
                        <a class="blocco nr" >{{(Number(numbers.first) + 1) + hotel.cols}}</a>
                      </div>
                    </div>
                  </el-radio>
                </el-form-item>

                <div class="spacer sm"></div>
                <!-- <el-form-item>
                  <el-button class="btn btn-blue block" v-on:click="changeStep">avanti</el-button>
                </el-form-item> -->
                <el-button-group>
                  <el-button class="btn btn-blue" v-if="grid.active !== 0" v-on:click="grid.active--" type="button" icon="el-icon-arrow-left">Indietro</el-button>
                  <el-button class="btn btn-blue" type="button" v-on:click="saveGrid">Salva Impostazioni <i class="el-icon-arrow-right el-icon-right"></i></el-button>
                </el-button-group>
              </el-form>

              </div>

              <div v-else class="guide">
                
              <h2>Sei pronto a partire</h2>

              <div class="spacer xs"></div>

              <p>Nella prossima schermata troverai una spiaggia libera, clicca su questa icona <i class="fas fa-wrench"></i> nel menu a sinistra per aggiungere o spostare gli ombrelloni.</p>

              <div class="spacer xs"></div>

              <p>Usa questo <i class="fas fa-umbrella-beach"></i> per aggiungere gli ombrelloni o clicca e trascina gli ombrelloni gia inseriti per spostarli.</p>

              <div class="spacer xs"></div>

              <el-button-group>
                  <el-button class="btn btn-blue" v-if="grid.active !== 0" v-on:click="grid.active--" type="button" icon="el-icon-arrow-left">Indietro</el-button>
                  <el-button class="btn btn-blue" type="button" v-on:click="saveGrid">Ok <i class="el-icon-arrow-right el-icon-right"></i></el-button>
                </el-button-group>

              </div>


    <div v-cloak class="grid" :style='style' v-cloak v-if="!loading" style="padding: 96px 0; max-width: 1200px; ">

      
      <div class="grid ombrello drag" v-for="(ombrello, index) in ombrelli">

        <div class="grid seat" v-if="!ombrello.free" :style="{background: hotel.colors.secondary}" :class="{ minimal : !hotel.poolsettings.chairs || !hotel.poolsettings.beds }" v-on:click="show(ombrello)">
          <div class="grid header" :class="{ single : !hotel.poolsettings.chairs || !hotel.poolsettings.beds, hidden : !hotel.poolsettings.chairs && !hotel.poolsettings.beds }">
            <img src="../assets/img/beach-deckchair-.png" v-if="hotel.poolsettings.beds">
            <img src="../assets/img/beach-chair.png" v-if="hotel.poolsettings.chairs">

            <span class="grid" v-if="hotel.poolsettings.chairs"><a v-on:click="removechair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.chairs}}<a v-on:click="addchair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span>

            <span class="grid" v-if="hotel.poolsettings.beds"><a v-on:click="removebed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.beds}}<a v-on:click="addbed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span>
          </div>

          <el-popover
            placement="top-start"
            :title="ombrello.guestsinday[0].room"
            width="200"
            trigger="hover"
            :content="ombrello.guestsinday[0].name"
            v-if="!hotel.poolsettings.guest && !hotel.poolsettings.room">
            <el-button slot="reference"><i class="fas fa-info-circle"></i></el-button>
          </el-popover>

          <div class="grid ident" v-if="hotel.poolsettings.room || hotel.poolsettings.guest">
          <!-- {{ombrello.guestsinday}} -->
            <span class="room" v-if="hotel.poolsettings.room">{{ombrello.guestsinday[0].room}}</span>
            <span v-if="ombrello.guest && hotel.poolsettings.guest" v-on:click="show(ombrello)">{{ombrello.guestsinday[0].name}}</span>
            <span v-if="!ombrello.guest && hotel.poolsettings.guest" v-on:click="show(ombrello)">no guest name</span>
            <span class="room" v-if="ombrello.guestsinday.length > 1">{{ombrello.guestsinday[1].room}}</span>
            <span v-if="ombrello.guest && ombrello.guestsinday.length > 1" v-on:click="show(ombrello)">{{ombrello.guestsinday[1].name}}</span>
          </div>
          <div class="grid data" :class="{ minimal : !hotel.poolsettings.chairs || !hotel.poolsettings.beds, hidden : !hotel.poolsettings.arrival }">
            <div class="grid nr">{{ombrello.ombrid}}</div>
            <div class="grid date" v-if="hotel.poolsettings.arrival || hotel.poolsettings.departure" :class="{ hidden : !hotel.poolsettings.arrival }">
              <span><span class="fa fa-chevron-right"></span> {{ombrello.arrival}}</span>
              <span><span class="fa fa-chevron-left"></span> {{ombrello.departure}}</span>
            </div>
          </div>
        </div>


          <div class="blocco seat free" :id="ombrello._id" v-if="ombrello.free">
            <a class="blocco nr" v-on:click="show(ombrello)" :id="ombrello._id">{{ombrello.ombrid}}</a>
          </div>

        <!-- </drag> -->
        </div>

        </div>


                <div class="spacer sm"></div>
                <div class="spacer sm"></div>


      </div> <!-- three -->
    
    <circle4 v-if="loading"></circle4>

    <!-- {{hotel}} -->
    <!-- <p>{{filteredSteps}}</p> -->
    <!-- <p v-for="option in grid.options">{{option}}</p> -->

    </div>

    </div>
  </div>
</template>

<script>
  import {Circle4} from 'vue-loading-spinner'
  import router from './../router'
  var host = process.env.ROOT_API
  export default {
    name: 'ombrelli',
    data () {
      return {
        loading: false,
        grid: {
          active: 0,
          options: [{
            title: 'Nome Hotel',
            desc: 'inserischi il nome del tuo Hotel e scegli il tuo colore preferito',
            visible: true
          },
          {
            title: 'Scelta spiaggia',
            desc: 'inserischi il nome del tuo Hotel e scegli il tuo colore preferito',
            visible: true
          },
          {
            title: 'Generator',
            desc: 'inserischi il nome del tuo Hotel e scegli il tuo colore preferito',
            visible: false
          },
          {
            title: 'Controlla e salva',
            desc: 'inserischi il nome del tuo Hotel e scegli il tuo colore preferito',
            visible: true
          }]
        },
        alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
        ombrelli: [],
        letters: {
          first: 'A',
          last: '',
          act: 0,
          row: 1
        },
        numbers: {
          first: 1,
          last: 0,
          act: 0
        },
        hotel: {
          name: '',
          rows: '',
          cols: '',
          lang: 'it',
          colors: {
            primary: '#19b5fe',
            secondary: '#753dfe'
          },
          beachtype: 'grid',
          gridtype: 'left'
        },
        rules: {
          name: [
              { required: true, message: 'prego inserisci il nome del tuo Hotel', trigger: 'blur' }
          ],
          // cols: [
          //     { required: false, message: 'prego inserisci un numero', trigger: 'blur' }
          // ],
          // rows: [
          //     { required: false, message: 'prego inserisci un numero', trigger: 'blur' }
          // ],
          letterfirst: [
              { required: true, message: 'prego inserisci una lettera', trigger: 'blur' },
              { min: 0, max: 1, message: 'Length should be 3 to 5', trigger: 'blur' }
          ],
          numberfirst: [
              { required: false, message: 'prego inserisci un numero', trigger: 'blur' }
          ]
        },
        error: {
          state: false,
          message: ''
        },
        success: {
          state: false,
          message: ''
        }
      }
    },
    components: {
      Circle4
    },
    methods: {
      next (formName) {
        console.log(formName)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.grid.active++
          } else {
            console.log('error submit!!')
            // return false
          }
        })
      },
      stepHandler (e, i) {
        console.log(e, i)
        this.grid.active = i
      },
      changeStep (type) {
        console.log(type)
        if (this.hotel.beachtype === 'grid') {
          this.grid.options[2].visible = true
          this.grid.active = 2
        } else {
          this.grid.options[2].visible = false
          this.grid.active = 3
        }
      },
      resetGrid () {
        console.log('resetGrid')
        this.ombrelli = []
        this.grid.firststep = true
        this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
        this.letters.row = 1
        this.numbers.act = this.numbers.first
        // this.grid.active = 2
        if (this.letters.first.length === 0 || this.hotel.gridtype === 'empty') {
          this.setemptyGrid()
        } else {
          this.setGrid()
        }
      },
      setemptyGrid () {
        var grid = this.hotel.cols * this.hotel.rows
        this.grid.active = 3
        this.hotel.gridtype = 'empty'
        console.log('ombrelli length', (this.ombrelli.length + 1), 'numbers act: ', this.numbers.act)
        if (this.ombrelli.length === grid) {
          console.log('done')
        } else {
          this.ombrelli.push({ombrid: (parseInt(this.numbers.act)), free: true})
          this.numbers.act++
          // if (grid > 99 && this.numbers.act <= 9) {
          //   console.log('case: 1')
          //   this.ombrelli.push({ombrid: '00' + (parseInt(this.numbers.act)), free: true})
          //   this.numbers.act++
          // } else if (grid > 99 && this.numbers.act <= 99) {
          //   console.log('case: 2')
          //   this.ombrelli.push({ombrid: '0' + (parseInt(this.numbers.act)), free: true})
          //   this.numbers.act++
          // } else {
          //   console.log('case: 3')
          //   this.ombrelli.push({ombrid: (parseInt(this.numbers.act)), free: true})
          //   this.numbers.act++
          // }
          this.setemptyGrid()
        }
      },
      setGrid () {
        this.grid.active = 3
        var grid = this.hotel.cols * this.hotel.rows
        // console.log(this.letters.first)
        if (this.letters.act === this.alphabet.length) {
          this.letters.act = 0
        }
        var act = this.alphabet[this.letters.act].toUpperCase()
        console.log('act: ', act, this.numbers.act)
        if (this.ombrelli.length === grid) {
          console.log('done')
        } else {
          // console.log('not done')
          this.ombrelli.push({ombrid: act + this.numbers.act, free: true})
          console.log('nr: ', act + this.numbers.act)
          if (this.hotel.gridtype === 'left') {
            this.numbers.act++
          } else {
            this.letters.act++
          }
          if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
            if (this.hotel.gridtype === 'left') {
              this.numbers.act = this.numbers.first
              this.letters.row++
              this.letters.act++
            } else {
              this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
              this.numbers.act++
              this.letters.row++
            }
            console.log('end of row', this.letters.row - 1, this.numbers.act)
          } else {}
          this.setGrid()
          // this.ombrelli.push({ombrid: act + this.numbers.act, free: true})
          // console.log('nr: ', act + this.numbers.act)
          // if (this.hotel.gridtype === 'left') {
          //   this.numbers.act++
          // } else {
          //   this.letters.act++
          // }
          // if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
          //   if (this.hotel.gridtype === 'left') {
          //     this.numbers.act = this.numbers.first
          //     this.letters.row++
          //     this.letters.act++
          //   } else {
          //     this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
          //     this.numbers.act++
          //     this.letters.row++
          //   }
          //   console.log('end of row', this.letters.row - 1, this.numbers.act)
          // } else {}
          // this.setGrid()
        }
      },
      saveGrid () {
        console.log(this.ombrelli)
        this.loading = true
        this.$http
          .post(host + '/api/savegrid', { hotel: this.hotel, ombrelli: this.ombrelli },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            if (this.hotel.beachtype === 'grid') {
              router.replace('ombrelli/' + data.body.hotel._id)
            } else {
              router.replace('Canvas/' + data.body.hotel._id)
            }
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'grid saved',
              type: 'success',
              duration: 500
            })
          })
      },
      inserthotel: function () {
        console.log(this.hotels)
        this.loading = true
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/addhotel', { hotel: this.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data.body.hotelid)
            router.replace('ombrelli/' + data.body.hotelid)
          }, (error) => {
            console.log(error)
          })
      }
    },
    beforeMount () {
      // this.getHotel()
    },
    computed: {
      filteredSteps (options) {
        return this.grid.options.filter(option => option.visible === true)
      },
      style () {
        return 'grid-template-columns: repeat(' + this.hotel.cols + ', 1fr); grid-template-rows: repeat(' + this.hotel.rows + ', auto);'
      },
      pregrid () {
        var next = this.alphabet.indexOf(this.letters.first.toLowerCase()) + 1
        if (this.letters.first.length > 0) {
          if (this.numbers.first < 10) {
            return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
          } else {
            return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.numbers.first) + 1) } }
          }
        } else {
          console.log('no letter', this.hotel.cols)
          if (this.numbers.first < 10) {
            return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
          } else {
            return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: (this.hotel.cols + 1) }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.hotel.cols) + 1) } }
          }
        }
      }
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// Addhotel.vue?a1c092b0